export default __webpack_public_path__ + "static/media/analytics-2.450e424b.svg";